module.exports = __webpack_public_path__ + "img/default-image-orange.60459a6e.png";